import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/solution/crm-new/crm_software.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud  p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={8} lg={8} xl={7} xxl={7} className="">
            <h2>
              Want to Build Your <span>CRM System?</span>
            </h2>
            <p>
              If you are excited to know about CRM development and how it can
              impact your business, we are here to facilitate you with a
              suitable solution.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Schedule a Consultation Call!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
